var map = {
	"./add-icon.svg": "e8c7",
	"./arrow-left.svg": "f6db",
	"./big-coin.svg": "ac47",
	"./block-user.svg": "2e36",
	"./check.svg": "4a24",
	"./coin.svg": "16fe",
	"./comment.svg": "997a",
	"./download.svg": "8215",
	"./enter.svg": "9acf",
	"./eye-crossed.svg": "8f21",
	"./eye.svg": "083f",
	"./eye2.svg": "2465",
	"./facebook.svg": "7e4b",
	"./fast-forward.svg": "5eb9",
	"./file.svg": "fe3c",
	"./google.svg": "4460",
	"./grid-blue.svg": "65f8",
	"./grid.svg": "14a4",
	"./list-active.svg": "98ee",
	"./list.svg": "484a",
	"./logout.svg": "a861",
	"./main.svg": "125a",
	"./more-horizontal.svg": "2ac7",
	"./more-vertical.svg": "e527",
	"./pause.svg": "69b6",
	"./pdf-file.svg": "a613",
	"./pencil.svg": "be21",
	"./phone.svg": "1f9a",
	"./play.svg": "af53",
	"./plus.svg": "4eb1",
	"./quotes.svg": "a4b4",
	"./reward.svg": "348e",
	"./search.svg": "0a17",
	"./settings.svg": "bc64",
	"./shuffle.svg": "85f4",
	"./sidebarButton.svg": "df43",
	"./sidebarClose.svg": "cbc0",
	"./slider-blue.svg": "8533",
	"./slider.svg": "ceea",
	"./store.svg": "3ff0",
	"./tasks.svg": "a697",
	"./timer.svg": "fd1c",
	"./trash-2.svg": "b81f",
	"./trash.svg": "9961",
	"./upload.svg": "cdcb",
	"./user-add.svg": "4d8b",
	"./user-group.svg": "fe5d",
	"./words-slider-prev.svg": "ca5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";